// Agent types offered wherever an intent lookup needs to be tagged: the single-sentence
// tester and the LLM vs legacy comparison runs. Kept in one place so a new agent type
// shows up in both without anyone having to remember the second list.
export const AGENT_TYPES = [
  { value: "Ecommerce", label: "Ecommerce" },
  { value: "HigherEdRetain", label: "HigherEdRetain" },
  { value: "HigherEdEnroll", label: "HigherEdEnroll" },
];

export default AGENT_TYPES;
